import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import axios from 'axios';

const Wrapper = styled.div`
  margin-top: 0;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ccc;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 24px 24px 24px;
  margin-bottom: 32px;
`;

const MainHeader = styled.h4`
  margin: 0;
  font-size: 24px;
`;

const Divider = styled.hr`
  margin: 12px 0 20px 0;
  border-top: 1px solid #ddd;
`;

const Label = styled.span`
  font-weight: bold;
  display: block;
  margin-bottom: 4px;
`;

const BackLink = styled(Link)`
  color: #479de6;
  text-decoration: none;
  margin-bottom: 16px;
  display: inline-block;

  &:hover {
    text-decoration: underline;
  }
`;

const EditButton = styled(Link)`
  margin-top: 16px;
`;

const ParentViewStudent = ({ history, match }) => {
  const { id } = match.params;
  const parent = useSelector((state) => state.parent);
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    // Find student from parent's students array
    const foundStudent = parent.students.find((s) => s.id === parseInt(id));
    if (foundStudent) {
      setStudent(foundStudent);
      setLoading(false);
    } else {
      // If not found in Redux state, fetch from API
      fetchStudent();
    }
  }, [id, parent.students]);

  const fetchStudent = async () => {
    try {
      const response = await axios.get(`/api/v2/students/${id}`);
      setStudent(response.data.student);
    } catch (error) {
      console.error('Error fetching student:', error);
      history.push('/my-account');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!student) {
    return <div>Student not found</div>;
  }

  return (
    <div className="bnl-dashboard-container">
      <div className="bnl-dashboard">
        <BackLink to="/my-account">← Back to Account</BackLink>

        <MainHeader>Student Information</MainHeader>
        <Divider />

        <Wrapper>
          <div>
            <Label>Name</Label>
            <p>
              {student.firstName} {student.lastName}
            </p>
          </div>

          {student.guardianRelationship &&
            student.guardianRelationship !== '' &&
            student.relationshipDisplay &&
            student.relationshipDisplay !== 'Not specified' && (
              <>
                <hr />
                <div>
                  <Label>Your Relationship</Label>
                  <p>{student.relationshipDisplay}</p>
                </div>
              </>
            )}

          <EditButton
            to={`/my-account/students/${id}/edit`}
            className="btn btn-primary"
          >
            Edit Student
          </EditButton>
        </Wrapper>
      </div>
    </div>
  );
};

export default withRouter(ParentViewStudent);
